/**

 *

 * Most modern mobile touch slider and framework with hardware accelerated transitions

 * http://146.56.218.109:18086/wechat/index.html

 *

 * Copyright 2024-2031 Vladimir Kharlampidi

 *

 * Released under the MIT License

 *

 */

document.addEventListener("DOMContentLoaded", function () {

    const $priceDom = $('#sp_price1');
  const $cPriceDom = $('#sp_price2');
  const $offPriceDom = $('.sp-price-group .sp-p span');
  const $numDom = $('#calcNumber');
  
  const productData = window.product || [];

  /** 获取当前选中的变量 */
  function getCur() {
    const opts = {
      option1: $('#sp-opt-group1 div.active').attr('data-val'),
      option2: $('#sp-opt-group2 div.active').attr('data-val'),
      option3: $('#sp-opt-group3 div.active').attr('data-val')
    };

    return productData.find(item => {
      return (!opts.option1 || item.option1 == opts.option1) &&
             (!opts.option2 || item.option2 == opts.option2) &&
             (!opts.option3 || item.option3 == opts.option3);
    });
  }

  /** 更新价格显示 */
  function changePrice() {
    const curVariant = getCur();
    if (!curVariant) return;

    const num = parseInt($numDom.val()) || 1;
    
    // 识别当前页面使用的小数点符号
    const currentText = $priceDom.text().trim();
    const decimalMatch = currentText.match(/([\.,])(\d+)(?!.*[\.,])/);
    
    const decimalSeparator = decimalMatch ? decimalMatch[1] : '.'; 
    const decimalLength = decimalMatch ? decimalMatch[2].length : 0; 

    // 格式化输出
    const formatValue = (cents) => {
      let val = (cents * num / 100).toFixed(decimalLength);
      if (decimalSeparator === ',') {
        val = val.replace('.', ',');
      }
      return val;
    };

    const price = formatValue(curVariant.price);
    const compare = formatValue(curVariant.compare_at_price);
    
    // 计算折扣
    let offPercent = 0;
    if (curVariant.compare_at_price > curVariant.price) {
      offPercent = 100 - Math.ceil((curVariant.price / curVariant.compare_at_price) * 100);
    }

    const priceRegex = /\d+(?:[.,]\d+)*/;
    const offRegex = /(\d+)(?=(?:<[^>]+>|\s)*%)/g;

    const updateHTML = ($el, regex, value) => {
      if ($el && $el.length) {
        const text = $el[0].textContent.trim();
        const newHtml = text.replace(regex, value);
        if ($el.html() !== newHtml) {
          $el.html(newHtml);
        }
      }
    };

    updateHTML($priceDom, priceRegex, price);
    updateHTML($cPriceDom, priceRegex, compare);
    updateHTML($offPriceDom, offRegex, offPercent);
  }
  
  // 绑定选项点击事件
  $(document).on('click', '.sp-option', function() {
      setTimeout(changePrice, 10);
  });

  $('.sp_buy_now').click(function () {

    let num = $numDom.val();
    let id = getCur().id;
    window.location.href = '/cart/' + id + ':' + num;

  });
  // 倒计时

  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();

    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();

    if (leftTime < 0) {
      setupNewCountdown();

      leftTime = 0;
    }

    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);

    leftH = leftH >= 10 ? leftH : "0" + leftH;

    leftM = leftM >= 10 ? leftM : "0" + leftM;

    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,

      minute: leftM,

      second: leftS,
    };
  }

  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);

    const currentTime = new Date();

    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }

  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();

    if (intervalId) clearInterval(intervalId);

    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();

      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);

      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );

      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();

  jQuery(".sp-scroll2").slide({
    mainCell: ".nav-imgs",

    autoPlay: true,

    effect: "leftMarquee",

    interTime: 12,

    vis: 1,

    scroll: 1,
  });

  new Swiper(".sp-swiper-fade", {
    autoplay: {
      disableOnInteraction: false,

      delay: 3500,
    },

    spaceBetween: 0,

    slidesPerView: "auto",

    centeredSlides: true,

    loop: true,
  });

  new Swiper(".sp-swiper-scroll-top", {
    spaceBetween: 160,

    loop: true,

    autoplay: true,

    autoplay: {
      disableOnInteraction: false,

      delay: 0,
    },

    speed: 8000,

    slidesPerView: "auto",
  });

  new Swiper(".sp-swiper-scroll-top-m", {
    spaceBetween: 250,

    loop: true,

    autoplay: true,

    autoplay: {
      disableOnInteraction: false,

      delay: 0,
    },

    speed: 10000,

    slidesPerView: "auto",
  });

  // new Swiper(".sp-swiper2", {

  //     autoplay: {

  //         delay: 3500,

  //         disableOnInteraction: false,

  //         reverseDirection: false,

  //     },

  //     slideShadows: true,

  //     slidesPerView: "auto",

  //     spaceBetween: 0,

  //     centeredSlides: true,

  //     loop: true,

  //     pagination: {

  //         el: ".sp-pagination",

  //         clickable: true,

  //     },

  //     navigation: {

  //         nextEl: ".sp-swiper-btn-next",

  //         prevEl: ".sp-swiper-btn-prev",

  //     },

  // });

  // Part3 对比轮播

  new Swiper(".sp3-compare-swiper", {
    autoplay: {
      delay: 3000,

      disableOnInteraction: false,
    },

    slidesPerView: 1,

    spaceBetween: 0,

    loop: true,

    pagination: {
      el: ".sp3-pagination",

      clickable: true,
    },

    navigation: {
      nextEl: ".sp3-next",

      prevEl: ".sp3-prev",
    },
  });

  new Swiper(".sp-swiper3-m", {
    autoplay: {
      delay: 3000,

      disableOnInteraction: false,
    },

    slidesPerView: 1,

    spaceBetween: 0,

    loop: true,

    pagination: {
      el: ".sp-swiper3-m-pagination",

      clickable: true,
    },
  });

  new Swiper(".sp-swiper1", {
    autoplay: true,

    autoplay: {
      disableOnInteraction: false,
    },

    spaceBetween: 20,

    loop: true,

    pagination: {
      el: ".sp-pagination1",

      clickable: true,
    },
  });

  new Swiper(".sp-swiper1-mobile", {
    autoplay: true,

    autoplay: {
      disableOnInteraction: false,
    },

    spaceBetween: 20,

    loop: true,

    pagination: {
      el: ".sp-pagination1-m",

      clickable: true,
    },
  });

  let _swiper = new Swiper(".sp-swiper-pro", {
    speed: 1,

    spaceBetween: 0,
  });

  // sp-part1-media 长图滚动轮播（支持手动滑动）

  new Swiper(".sp-media-swiper", {
    autoplay: {
      delay: 0,

      disableOnInteraction: false,
    },

    speed: 12000,

    spaceBetween: 0,

    loop: true,

    slidesPerView: "auto",

    freeMode: true,

    grabCursor: true,
  });

  // sp-part5 颜色选项轮播（移动端）- 走马灯效果

  new Swiper(".sp5-color-swiper", {
    autoplay: {
      delay: 0,

      disableOnInteraction: false,
    },

    speed: 3000,

    spaceBetween: 30,

    loop: true,

    slidesPerView: "auto",

    freeMode: true,

    allowTouchMove: true,

    grabCursor: true,
  });

  // 移动端 guarantee-tags 轮播 - 走马灯效果（仅移动端）

  if (document.body.clientWidth <= 1080) {
    new Swiper(".sp-guarantee-swiper", {
      autoplay: {
        delay: 0,

        disableOnInteraction: false,

        pauseOnMouseEnter: false,
      },

      speed: 4000,

      spaceBetween: 40,

      loop: true,

      loopAdditionalSlides: 3,

      slidesPerView: "auto",

      freeMode: {
        enabled: true,

        momentum: false,
      },

      allowTouchMove: false,

      grabCursor: false,
    });
  }

  // 移动端 sp-part2 问题卡片轮播

  new Swiper(".sp2-problems-swiper", {
    autoplay: {
      delay: 0,

      disableOnInteraction: false,
    },

    speed: 5000,

    spaceBetween: 30,

    loop: true,

    slidesPerView: "auto",

    freeMode: true,

    allowTouchMove: true,

    grabCursor: true,
  });

  // sp-part5 底部图片走马灯

  new Swiper(".sp5-gallery-swiper", {
    autoplay: {
      delay: 0,

      disableOnInteraction: false,
    },

    speed: 5000,

    spaceBetween: 20,

    loop: true,

    slidesPerView: "auto",

    freeMode: true,

    allowTouchMove: true,

    grabCursor: true,
  });

  /**

   * 价格配置: { combo: [现价, 原价] }

   * headphones: 仅耳机

   * powerbank: 耳机 + 充电宝

   */

  var priceConfig = {
    headphones: [37.99, 59.98],

    powerbank: [49.99, 79.98],
  };

  /**

   * 图片索引映射: { color-combo: index }

   * 6张图片对应：white-headphones(0), white-powerbank(1), black-headphones(2), black-powerbank(3), purple-headphones(4), purple-powerbank(5)

   */

  var imageIndexMap = {
    "white-headphones": 0,

    "white-powerbank": 1,

    "black-headphones": 2,

    "black-powerbank": 3,

    "purple-headphones": 4,

    "purple-powerbank": 5,
  };

  /**

   * 更新产品图片和价格

   * 根据当前选中的颜色和组合，切换对应图片并更新价格

   */

  function updateProductDisplay() {
    var color = $("#sp-opt-group1 .sp-option.active").index();

    var combo = $("#sp-opt-group2 .sp-option.active").index();

    let imgIndex = combo+ color*2

    if (typeof imgIndex !== "undefined") {
      _swiper.slideTo(imgIndex);
    }

  }

  // 颜色选项点击事件

  $("#sp-opt-group1 .sp-option").click(function () {
    $(this).siblings().removeClass("active");

    $(this).addClass("active");

    updateProductDisplay();
  });

  // 组合选项点击事件

  $("#sp-opt-group2 .sp-option").click(function () {
    $(this).siblings().removeClass("active");

    $(this).addClass("active");

    updateProductDisplay();
  });

  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");

      if (document.body.clientWidth <= 1080) {
        let scale = document.body.clientWidth / 1080;

        $("#root").css("zoom", scale);
      } else {
        const scale = document.body.clientWidth / 1920;

        $("#root").css("zoom", scale);
      }

      window.addEventListener(
        "resize",

        (function () {
          var timer;

          return function () {
            if (timer) clearTimeout(timer);

            timer = setTimeout(function () {
              $("#root").css("zoom", "normal");

              if (document.body.clientWidth <= 1080) {
                let scale = document.body.clientWidth / 1080;

                $("#root").css("zoom", scale);
              } else {
                const scale = document.body.clientWidth / 1920;

                $("#root").css("zoom", scale);
              }
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载

      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片

      const config = {
        rootMargin: "0px 0px 1300px 0px",

        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(
        function (
          entries,

          observer
        ) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              // 当图片进入视口时

              const image = entry.target;

              const dataSrc = image.getAttribute("data-src");

              image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址

              lazyLoadObserver.unobserve(image); // 停止观察该图片
            }
          });
        },

        config
      );

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载

      // 检查数组数据结构

      if (Array.isArray(imageArray[0])) {
        // 处理二维数组

        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();

            img.src = url;
          });
        });
      } else {
        // 处理一维数组

        imageArray.forEach((url) => {
          const img = new Image();

          img.src = url;
        });
      }
    }

    lazyLoadImages();

    // preloadImages();

    // 找到所有跳转套餐的锚点链接

    var links = document.querySelectorAll('a[href^="#shopping"]');

    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为

        // 方式一

        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点

        const offsetTop =
          document.body.clientWidth <= 1080
            ? targetElement.offsetTop - $(".sp-nav").height()
            : targetElement.offsetTop;

        let sptop = document.body.clientWidth <= 1080 ? -310 : -100;

        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            sptop * $("div#root").css("zoom"),

          behavior: "smooth", // 使用 smooth 实现平滑滚动
        });
      });
    });

    // IOS字体多了间距的处理 给节点添加 sp_system 类名

    // 判断当前用户是安卓端还是iOS端

    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    var isAndroid = /android/i.test(userAgent);

    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log("Android");
    } else if (isIOS) {
      console.log("iOS");
    } else if (isPC) {
      console.log("PC");
    } else {
      $(".sp_system").css("letter-spacing", "-4px");
    }

    // Part7 轮播

    new Swiper(".sp-swiper2", {
      autoplay: {
        delay: 2500,

        disableOnInteraction: false,

        reverseDirection: false,
      },

      slideShadows: true,

      slidesPerView: "auto",

      spaceBetween: 0,

      centeredSlides: true,

      loop: true,

      pagination: {
        el: ".sp-pagination",

        clickable: true,
      },
    });

    // Part1 底部特性走马灯

    new Swiper(".sp-bottom-features-swiper", {
      autoplay: {
        delay: 0,

        disableOnInteraction: false,
      },

      speed: 3000,

      slidesPerView: "auto",

      spaceBetween: 0,

      loop: true,

      freeMode: {
        enabled: true,

        momentum: false,
      },

      grabCursor: false,

      allowTouchMove: false,
    });
  }

  mainRender();

  var sp_price1 = 16.99;

  var sp_price2 = 37.99;

  function calcTotal(price, num) {
    let result = Number(price) * Number(num);

    return result.toFixed(2);
  }

  $(".sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];

    let num = Number(input.value) - 1;

    if (num > 0) {
      input.value = num;
    }

    changePrice()
  });

  $(".sp-add").click(function () {
    let input = $(this).siblings("input")[0];

    let num = Number(input.value) + 1;

    input.value = num;

    changePrice()
  });

  // 标题文本渐出

  const graduallyList = document.getElementsByClassName("gradually");

  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span");

    const paragraph = gradually.querySelector(".sp-sub-title");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画

            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;

              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");

              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;

                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落

            const totalDelay = spans.length * 0.1 + 0.3;

            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;

              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );

    observer.observe(gradually);
  }

  // 菜单

  $(".sp-menu-btn").click(function (e) {
    $(".sp-menu-mask").show();
  });

  $(".sp-menu-mask").click(function (e) {
    // if ($(e.target).closest(".sp-menu-mask li").length > 0) {

    // } else {

    $(".sp-menu-mask").hide();

    // }
  });

  // 滚动隐藏顶部

  if (
    $(window).scrollTop() >
    $(".sp_header").height() * $("div#root").css("zoom")
  ) {
    $(".sp_header-wrap").addClass("sp-fixed");
  } else {
    $(".sp_header-wrap").removeClass("sp-fixed");
  }

  let spTimer = null;

  let spHasShown = false; // 防止重复显示

  $(window).scroll(function () {
    if (
      $(window).scrollTop() >
      $(".sp_header").height() * $("div#root").css("zoom")
    ) {
      $(".sp_header-wrap").addClass("sp-fixed");
    } else {
      $(".sp_header-wrap").removeClass("sp-fixed");
    }

    // 滚动添加底部

    if (spHasShown) return; // 已经显示就不再触发

    // 如果没有定时器，则开始计时

    if (!spTimer && $(window).scrollTop() > 1000) {
      spTimer = setTimeout(function () {
        document.querySelector(".sp-btn-style2").style.display = "flex";

        spHasShown = true; // 标记为已显示
      }, 1000);
    }
  });


  // let initNum = 0;

  // $(document).on("click", ".sp_add_cart", function() {

  //     // 购物车加购动效

  //     $(this).children("img").addClass("on");

  //     $(".sp-cart .num").show();

  //     setTimeout(function() {

  //         $(" .cart-btn").children("img").removeClass("on");

  //     }, 500);

  //     $(" .sp-cart").addClass("on");

  //     setTimeout(function() {

  //         $(".sp-cart").removeClass("on");

  //     }, 500);

  //     let spNum = $(".sp_product_part #calcNumber")[0].value;

  //     initNum += Number(spNum);

  //     // $("#calcNumber").val(1);

  //     $(".cardNum").each(function() {

  //         $(this).html(initNum);

  //     });

  //     $(".cardNum").removeClass("sp-gray");

  //     // handleAddToCart(initNum);

  //     var imgs = $(".sp_product_part .swiper-slide-active").find("img");

  //     // var imgs = $(".sp_product_part .sp-img-p.active");

  //     imgs.each(function() {

  //         var $img = $(this);

  //         var flyer = $img[0].cloneNode(true);

  //         flyer.classList.add("sp_clone");

  //         // 使用 getBoundingClientRect 获取相对视口的坐标，配合 position: fixed

  //         var imgRect = $img[0].getBoundingClientRect();

  //         $(".sp_product_part").append(flyer);

  //         $(flyer).css({

  //             width: $img[0].width,

  //             height: $img[0].height,

  //             background: "#e7e9ef",

  //             position: "fixed",

  //             top: imgRect.top,

  //             left: imgRect.left,

  //             "z-index": 99,

  //         });

  //         let finish;

  //         if (document.body.clientWidth <= 1080) {

  //             // 移动端：检查底部栏是否可见，不可见则使用固定坐标（屏幕底部右侧）

  //             finish = $(".sp-btn-style2 .sp-cart");

  //             var finishTop, finishLeft;

  //             if (finish.length && finish.is(":visible")) {

  //                 var finishRect = finish[0].getBoundingClientRect();

  //                 finishTop = finishRect.top;

  //                 finishLeft = finishRect.left + finish.width() / 2;

  //             } else {

  //                 // 底部栏不可见时，飞向屏幕底部右侧位置

  //                 finishTop = window.innerHeight - 80;

  //                 finishLeft = window.innerWidth - 100;

  //             }

  //             $(flyer).animate({

  //                     top: finishTop,

  //                     left: finishLeft,

  //                     width: 50,

  //                     height: 50,

  //                     opacity: 0.4,

  //                 },

  //                 500,

  //                 "linear",

  //                 function() {

  //                     $(this).animate({

  //                             width: 0,

  //                             height: 0,

  //                             opacity: 0,

  //                         },

  //                         0,

  //                         function() {

  //                             $(this).detach();

  //                         }

  //                     );

  //                 }

  //             );

  //         } else {

  //             finish = $(".sp_pc .sp-cart");

  //             var finishRect = finish[0].getBoundingClientRect();

  //             $(flyer).animate({

  //                     top: finishRect.top,

  //                     left: finishRect.left + finish.width() / 2,

  //                     width: 50,

  //                     height: 50,

  //                     opacity: 0.4,

  //                 },

  //                 500,

  //                 "linear",

  //                 function() {

  //                     $(this).animate({

  //                             width: 0,

  //                             height: 0,

  //                             opacity: 0,

  //                         },

  //                         0,

  //                         function() {

  //                             $(this).detach();

  //                         }

  //                     );

  //                 }

  //             );

  //         }

  //     });

  // });

  let initNum = 0;
  $(document).on("click", ".sp_add_cart", function () {
    // 购物车加购动效

    $(this).children("img").addClass("on");
    $(".sp-cart .num").show();
    setTimeout(function () {
      $(" .cart-btn").children("img").removeClass("on");
    }, 500);
    $(" .sp-cart").addClass("on");
    setTimeout(function () {
      $(".sp-cart").removeClass("on");
    }, 500);

    var data = {
      id: getCur().id,
      quantity: $('#calcNumber').val(),
    }
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
          // $("#cardNum").html(result.item_count);
          $('.cardNum').each(function () {
            $(this).html(result.item_count)
            $(this).removeClass('sp-gray')
          })
        })
      },
      dataType: 'json',
    })
    var imgs = $(".sp_product_part .swiper-slide-active").find("img");
    // var imgs = $(".sp_product_part .sp-img-p.active");

    imgs.each(function () {
      var $img = $(this);
      var flyer = $img[0].cloneNode(true);
      flyer.classList.add("sp_clone");

      $(".sp_product_part").append(flyer);
      $(flyer).css({
        width: $img[0].width,
        height: $img[0].height,
        background: "#e7e9ef",
        position: "fixed",

        top: $img[0].offsetTop,
        left: $img.offset().left,
        "z-index": 99,
      });
      let finish;
      if (document.body.clientWidth <= 1080) {
        finish = $(".sp-btn-style2 .sp-cart");

        $(flyer).animate(
          {
            top: $(".sp-btn-style2")[0].offsetTop,
            left:
              $(".sp-btn-style2 .sp-area2")[0].offsetLeft +
              finish.width() / 2 +
              500,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          "linear",
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach();
              }
            );
          }
        );
      } else {
        finish = $(".sp_pc .sp-cart");
        $(flyer).animate(
          {
            top: finish[0].offsetTop,
            left: finish[0].offsetLeft + finish.width() / 2,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          "linear",
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach();
              }
            );
          }
        );
      }
    });
  });

  // 问答

  $(".q-row").click(function () {
    $(this).parent().toggleClass("sp-show");
  });

  // 文本渐出动画

  const graduallyList2 = document.getElementsByClassName("sp-fade-box");

  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll(".sp-ani");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`;

              span.style.animationDelay = `${index * 0.5 + 0.5}s`;
            });

            observerAni.unobserve(gradually2);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );

    observerAni.observe(gradually2);
  }

  // 文本渐出动画

  const graduallyList3 = document.getElementsByClassName("sp-fade-box2");

  for (let gradually3 of graduallyList3) {
    const paragraph3 = gradually3.querySelectorAll(".sp-ani2");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph3.forEach((span, index) => {
              span.style.animation = `sp-fade-left 1s ease forwards`;

              span.style.animationDelay = `${index * 0.3 + 1}s`;
            });

            observerAni.unobserve(gradually3);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );

    observerAni.observe(gradually3);
  }

  // 统一处理所有 #shopping 链接的跳转

  document.querySelectorAll('a[href="#shopping"]').forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();

      var target = document.getElementById("shopping");

      if (target) {
        target.scrollIntoView({
          behavior: "smooth",

          block: "start",
        });
      }
    });
  });

  // sp-part4 底部轮播 - 参考挂烫机项目效果

  new Swiper(".sp_pc .sp4-swiper", {
    autoplay: {
      delay: 2500,

      disableOnInteraction: false,

      reverseDirection: false,
    },

    slideShadows: true,

    slidesPerView: "auto",

    spaceBetween: 0,

    centeredSlides: true,

    loop: true,

    pagination: {
      el: ".sp_pc .sp4-pagination",

      clickable: true,

      type: "bullets",
    },
  });

  // sp-part4 底部轮播 - 移动端

  new Swiper(".sp_mobile .sp4-swiper", {
    autoplay: {
      delay: 2500,

      disableOnInteraction: false,

      reverseDirection: false,
    },

    slideShadows: true,

    slidesPerView: "auto",

    spaceBetween: 0,

    centeredSlides: true,

    loop: true,

    pagination: {
      el: ".sp_mobile .sp4-pagination",

      clickable: true,

      type: "bullets",
    },
  });
});

// QA3 展开/收起功能

$(".sp-qa3-question").on("click", function () {
  var $currentItem = $(this).closest(".sp-qa3-item");

  var $answer = $currentItem.find(".sp-qa3-answer");

  if ($currentItem.hasClass("active")) {
    $answer.slideUp(300);

    $currentItem.removeClass("active");
  } else {
    $(".sp-qa3-item").removeClass("active");

    $(".sp-qa3-answer").slideUp(300);

    $currentItem.addClass("active");

    $answer.slideDown(300);
  }
});

// QA2 展开/收起功能

$(".sp-qa2-question").on("click", function () {
  var $currentItem = $(this).closest(".sp-qa2-item");

  var $answer = $currentItem.find(".sp-qa2-answer");

  if ($currentItem.hasClass("active")) {
    $answer.slideUp(300);

    $currentItem.removeClass("active");
  } else {
    $(".sp-qa2-item").removeClass("active");

    $(".sp-qa2-answer").slideUp(300);

    $currentItem.addClass("active");

    $answer.slideDown(300);
  }
});

// ========== sp-part4 轮播功能 ==========
$(document).ready(function () {
  document.querySelectorAll(".sp-part4").forEach(function (part4) {
    var slides = part4.querySelectorAll(".sp4-slide");
    var dots = part4.querySelectorAll(".sp4-dot");
    var prevBtn = part4.querySelector(".sp4-arrow-prev");
    var nextBtn = part4.querySelector(".sp4-arrow-next");
    var currentIndex = 0;
    var autoplayInterval = null;
    var autoplayDelay = 4000;

    function goToSlide(index) {
      var total = slides.length;
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      var prevIndex = (index - 1 + total) % total;
      var nextIndex = (index + 1) % total;

      slides.forEach(function (slide, i) {
        slide.classList.remove(
          "sp4-slide-active",
          "sp4-slide-prev",
          "sp4-slide-next",
          "sp4-slide-hidden"
        );
        if (i === index) {
          slide.classList.add("sp4-slide-active");
        } else if (i === prevIndex) {
          slide.classList.add("sp4-slide-prev");
        } else if (i === nextIndex) {
          slide.classList.add("sp4-slide-next");
        } else {
          slide.classList.add("sp4-slide-hidden");
        }
      });

      dots.forEach(function (dot, i) {
        dot.classList.remove("sp4-dot-active");
        if (i === index) {
          dot.classList.add("sp4-dot-active");
        }
      });
      currentIndex = index;
    }

    function nextSlide() {
      goToSlide(currentIndex + 1);
    }

    function prevSlide() {
      goToSlide(currentIndex - 1);
    }

    function startAutoplay() {
      stopAutoplay();
      autoplayInterval = setInterval(nextSlide, autoplayDelay);
    }

    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        prevSlide();
        startAutoplay();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        nextSlide();
        startAutoplay();
      });
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener("click", function () {
        goToSlide(index);
        startAutoplay();
      });
    });

    var touchStartX = 0;
    var touchEndX = 0;
    var sliderWrap = part4.querySelector(".sp4-slider-wrap");
    if (sliderWrap) {
      // 移动端触摸滑动
      sliderWrap.addEventListener(
        "touchstart",
        function (e) {
          touchStartX = e.changedTouches[0].screenX;
          stopAutoplay();
        },
        {
          passive: true,
        }
      );

      sliderWrap.addEventListener(
        "touchend",
        function (e) {
          touchEndX = e.changedTouches[0].screenX;
          var diff = touchStartX - touchEndX;
          if (Math.abs(diff) > 50) {
            if (diff > 0) {
              nextSlide();
            } else {
              prevSlide();
            }
          }
          startAutoplay();
        },
        {
          passive: true,
        }
      );

      // PC端鼠标拖拽滑动
      var mouseStartX = 0;
      var isDragging = false;

      sliderWrap.addEventListener("mousedown", function (e) {
        mouseStartX = e.clientX;
        isDragging = true;
        stopAutoplay();
        e.preventDefault();
      });

      sliderWrap.addEventListener("mousemove", function (e) {
        if (!isDragging) return;
        e.preventDefault();
      });

      sliderWrap.addEventListener("mouseup", function (e) {
        if (!isDragging) return;
        isDragging = false;
        var diff = mouseStartX - e.clientX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) {
            nextSlide();
          } else {
            prevSlide();
          }
        }
        startAutoplay();
      });

      sliderWrap.addEventListener("mouseleave", function (e) {
        if (isDragging) {
          isDragging = false;
          var diff = mouseStartX - e.clientX;
          if (Math.abs(diff) > 50) {
            if (diff > 0) {
              nextSlide();
            } else {
              prevSlide();
            }
          }
          startAutoplay();
        }
      });
    }

    // 移除 hover 暂停逻辑，保持始终自动播放

    goToSlide(0);
    startAutoplay();
  });
});
